//save user iterations in localStorage
class ActionsWebFactory{

    static save(actionsWeb){
        localStorage.setItem('actionsWeb',JSON.stringify(actionsWeb));
    }
    static initialize(){
        const actionsWeb={
            categoryclick :false,
            item2:null,
            item3:null
        };
        localStorage.setItem('actionsWeb',JSON.stringify(actionsWeb));

    }

    static  setItemActionsWeb(index,value){
        let actionsWeb={};
        if(localStorage.getItem('actionsWeb')){
            actionsWeb=JSON.parse(localStorage.getItem('actionsWeb'));
        }
        localStorage.setItem('actionsWeb',JSON.stringify({...actionsWeb,[index]:value}));
    }
    static getItemActionsWeb(index=''){
        let actionsWeb={};
        if(localStorage.getItem('actionsWeb')){
            actionsWeb=JSON.parse(localStorage.getItem('actionsWeb'));
            return actionsWeb[index]?actionsWeb[index]:'';
        }
    }

    
    

  


}
export default ActionsWebFactory;